export const Logo = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Eddie Kirk ADA scan mark">
    <rect width="64" height="64" rx="14" fill="#0B0F1A" stroke="rgba(255,176,32,0.35)" />
    <path d="M21 12h-7a2 2 0 0 0-2 2v7" stroke="#FFB020" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <path d="M43 12h7a2 2 0 0 1 2 2v7" stroke="#FFB020" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <path d="M21 52h-7a2 2 0 0 1-2-2v-7" stroke="#FFB020" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <path d="M43 52h7a2 2 0 0 0 2-2v-7" stroke="#FFB020" strokeWidth="4.5" fill="none" strokeLinecap="round" />
    <rect x="16" y="28.5" width="32" height="7" rx="3.5" fill="#00E5FF" />
    <circle cx="32" cy="32" r="2.6" fill="#0B0F1A" />
  </svg>
);

export const Wordmark = ({ compact = false }) => (
  <span className="flex flex-col leading-none">
    <span className="font-display text-lg sm:text-xl tracking-wide text-white">
      EDDIE&nbsp;KIRK
    </span>
    {!compact && (
      <span className="font-mono text-[9px] tracking-[0.3em] text-brandamber mt-1">
        ADA&nbsp;TECH&nbsp;ADVOCATE
      </span>
    )}
  </span>
);
